import { Grid } from "@mui/material"

import { LinearLoading } from 'common'

export const InfoLawyerPayments = ({ useFetchInit }) => {
    const { FetchData } = useFetchInit
    const { fetchInfoProcessLawyer } = FetchData
    const { dataInfoProcessLawyer, loadingFetchInfoProcessLawyer } = fetchInfoProcessLawyer
    return (
        <>
            {(loadingFetchInfoProcessLawyer) && (<LinearLoading />)}
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ marginBottom: 2, marginTop: 2 }}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>IDENTIFICADOR:</strong> {dataInfoProcessLawyer[0]?.process_number || '' }
                        </span>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>CLIENTE:</strong> {dataInfoProcessLawyer[0]?.info_cliente || '' }
                        </span>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>FECHA INICIO:</strong> {dataInfoProcessLawyer[0]?.date_start || '' }
                        </span>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>COSTO DEL SERVICIO:</strong> Q {parseFloat(dataInfoProcessLawyer[0]?.initial_amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '' }
                        </span>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>CATEGORIA DE PROCESO:</strong> {dataInfoProcessLawyer[0]?.category_process || '' }
                        </span>
                    </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>PROCESO (JUZGADO):</strong> {dataInfoProcessLawyer[0]?.jdo_process_number || '' }
                        </span>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>GASTOS EXTRAS:</strong> Q {parseFloat(dataInfoProcessLawyer[0]?.other_expense_total).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '' }
                        </span>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>TOTAL A PAGAR:</strong> Q {parseFloat(dataInfoProcessLawyer[0]?.total_pagar).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '' }
                        </span>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>TOTAL RECIBIDO:</strong> Q {parseFloat(dataInfoProcessLawyer[0]?.total_recibido).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '' }
                        </span>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>SALDO:</strong> Q {parseFloat(dataInfoProcessLawyer[0]?.saldo_total).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '' }
                        </span>
                    </div>
                </Grid>
            </Grid>
        </>
    )
}
